export default __webpack_public_path__ + "static/media/Moneris_Logo_BIL_White.ea682cfb.png";